<div class="container">
  <form [formGroup]="newDocumentForm" (ngSubmit)="submitNewDocumentForm()">
    <div class="row">
      <mat-toolbar>
        <button mat-icon-button type="button" matTooltip="Atr&aacute;s" aria-label="Atrás" (click)="onBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        &nbsp;
        <button mat-stroked-button type="submit" (click)="isPreview=true" matTooltip="Mostrar vista previa"
          aria-label="Mostrar vista previa" [disabled]="!newDocumentForm.valid || fetchingSubmitForm">
          <div class="btn-login-content">
            @if (fetchingSubmitForm && isPreview) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            Vista previa
            }
          </div>
        </button>
        &nbsp;
        <button class="update-button" type="submit" [disabled]="!newDocumentForm.valid || fetchingSubmitForm"
          mat-flat-button>
          <div class="btn-login-content">
            @if (fetchingSubmitForm && !isPreview) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            <p>Aceptar</p>
            }
          </div>
        </button>
        &nbsp;
        @if (true){
        <a mat-stroked-button (click)="location.back()">Cancelar</a>
        }@else{
        <button type="reset" mat-stroked-button>Cancelar</button>
        }
      </mat-toolbar>
    </div>
    <br>
    <fieldset class="mat-mdc-card sgd-card participantes-fieldset">
      <legend>&nbsp;</legend>
      <button mat-flat-button color="accent" type="button" (click)="openDlgDestino()" class="buscar-participantes-btn">
          <mat-icon>person_search</mat-icon> Buscar participantes
      </button>
      <mat-card class="sgd-card" style="border: 0; margin-top: 0px;">
        <div class="participantes-container">
          <mat-card-subtitle>
            De: &nbsp;
            @if (newDocumentForm.controls.participantes.hasError('requiredOrigen')) {
            <mat-error class="participante-label">Elegir al menos un remitente!</mat-error>
            }
            @for (participante of participantes.origen; track $index) {
            <div class="participante-label">
              <!--<img src="assets/vacio.png" class="foto-para">-->
              <mat-icon>account_circle</mat-icon>
              <span>
                {{participante.nombres | capitalize}}
              </span>
            </div>
            }
          </mat-card-subtitle>
          <mat-card-subtitle>
            Para:
            @if (newDocumentForm.controls.participantes.hasError('requiredDestino')) {
            <mat-error class="participante-label">Elegir al menos un destinatario!</mat-error>
            }
            @for (participante of participantes.destinoBuzon; track $index) {
            <div class="participante-label">
              <mat-icon>person</mat-icon>
              <span>
                {{participante.cargo}}
              </span>
            </div>
            }
            @for (participante of participantes.destino; track $index) {
            <div class="participante-label">
              <!--<img src="assets/vacio.png" class="foto-para">-->
              <mat-icon>person</mat-icon>
              <span>
                {{participante.nombres | capitalize}}
              </span>
            </div>
            }
          </mat-card-subtitle>
          <mat-card-subtitle>
            @if (participantes.copia.length){
            Copia:
            @for (participante of participantes.copia; track $index) {
            <!--<img src="assets/vacio.png" class="foto-para">-->
            <div class="participante-label">
              <mat-icon>contact_page</mat-icon>
              <span>
                {{participante.nombres | capitalize}}
              </span>
            </div>
            }
            }
          </mat-card-subtitle>
        </div>
      </mat-card>
    </fieldset>

    <div class="row" style="margin: 0;">
      <div class="col-7">
        <mat-form-field class="full-width">
          <mat-label>Elegir una fecha</mat-label>
          <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="documentDate">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-5">
        <mat-form-field class="full-width">
          <mat-label>Tipo documento</mat-label>
          <mat-select (selectionChange)="manageChangedDocumentType($event)" [(value)]="defaultDocumentType"
            formControlName="documentType">
            @for (documentType of documentTypes; track $index) {
            <mat-option value={{documentType.id}}>{{documentType.descripcion}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-7">
        <mat-form-field class="full-width">
          <mat-label>N&uacute;mero de documento</mat-label>
          <!--<mat-icon style="padding: 0 4px;" matPrefix class="material-symbols-outlined numeracion-field"
            matTooltip="Los s&iacute;mbolos #### representa el n&uacute;mero que se generar&aacute; al guardar el documento">help</mat-icon>
          <button type="button" mat-icon-button matSuffix class="numeracion-field" matTooltip="Editar n&uacute;mero"
            (click)="onEditConfirm()">
            <mat-icon>edit</mat-icon>
          </button>-->
          <input matInput formControlName="numeracion" #numeracionInput [readonly]="readOnlyNumeracion" maxlength="100" />
          @if(!isEdit){
          <button type="button" mat-icon-button matSuffix class="numeracion-field"
            matTooltip="Seleccionar la numeraci&oacute;n" (click)="onDlgNumeracion()">
            <mat-icon>list</mat-icon>
          </button>
          }
        </mat-form-field>
      </div>

      <div class="col-md-5">
        <mat-form-field class="full-width">
          <mat-label>N&uacute;mero referencia</mat-label>
          <input matInput formControlName="referenceNumber" />
        </mat-form-field>
      </div>
      <div class="col-12 d-flex align-items-center">
        <mat-form-field class="full-width small-form-field" style="flex: 1">
          <mat-label>Asunto</mat-label>
          <input matInput formControlName="asunto" type="" />
          @if (newDocumentForm.controls.asunto.getError('maxlength')) {
          <mat-error class="participante-label">Longitud máxima de 250 caracteres</mat-error>
          }
        </mat-form-field>
          @if (editor() == EditorType.odt) {
          <button mat-icon-button class="fullscreen-button" [class.active]="editorHasFocus || fullscreenActive" [color]="(editorHasFocus || fullscreenActive) ? 'primary' : ''" aria-label="Pantalla completa" type="button" [disabled]="!(editorHasFocus || fullscreenActive)" [matTooltip]="(editorHasFocus || fullscreenActive) ? 'Pantalla completa' : 'Seleccione el documento'" (click)="onFullscreen()">
            <mat-icon>fullscreen</mat-icon>
          </button>
          }
      </div>
    </div>
    
    @if (editor() == EditorType.html) {
      <ngx-suneditor [options]="editorOptions" (onChange)="manageEditorContentChange($event)">ddd</ngx-suneditor>
    }

    @if (editor() == EditorType.odt) {
      @if (!collaboraUrl) {
      <div style="display: flex; align-items: center; justify-content: center; height: 60vh; flex-direction: column;">
        <mat-spinner diameter="50"></mat-spinner>
        <p style="margin-top: 1rem;">Inicializando editor...</p>
      </div>
      }@else{
      <app-collabora-editor #collaboraEditorComponent [editorUrl]="collaboraUrl" [fileName]="'documento.odt'"
        [fileExtension]="'odt'" [readOnly]="false" (editorReady)="onCollaboraReady()"
        (contentChanged)="onCollaboraContentChanged()" (error)="onCollaboraError($event)"
        (focusChange)="onEditorFocus($event)"
        style="display: block; width: 100%; height: 60vh; min-height: 500px;">
      </app-collabora-editor>
      }
    }
  </form>
</div>